/**
 * @license
 * Copyright (c) 2017, Barclays Africa Technology, All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file
 */

import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Effect, Actions, toPayload } from '@ngrx/effects';

import { Observable } from 'rxjs/Observable';
import '@api/rxjs-operators';

import { User } from '@api/models/user'
import { UserProfile } from '../../models/user';

/* Celine actions */
import * as user from '@api/store/actions/user.actions'

/* Threshold actions */
import * as thresholdUserActions from '../../store/actions/user.actions';

/* Threshold services */
import { UserProfileService } from '../../services';

@Injectable()
export class ThresholdUserEffects {

    constructor(
        private actions$: Actions, 
        private userProfileService: UserProfileService) {
    }

    /**
     * User was successfully logged in
     */
    @Effect()
    loginSuccess$: Observable<Action> = this.actions$
        .ofType(user.LOGIN_SUCCESS)
        .map(toPayload)
        .map((user: User) => new thresholdUserActions.LoadUserProfilesAction(user));

    @Effect()
    fetchUserProfiles$: Observable<Action> = this.actions$
        .ofType(thresholdUserActions.LOAD_USER_PROFILES)
        .map(toPayload)
        .switchMap((user: User) => this.userProfileService.getUserProfiles(user))
        .map((userProfiles: UserProfile[]) => new thresholdUserActions.LoadUserProfilesSuccessAction(userProfiles));
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/store/effects/user.effects.ts